import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetLungGauge() {

  return (

      <GaugeWithNeedle realAge={64} chronologicalAge={62} />
    
  );
};




